import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import OrderManagement from '../entities/ordermanagement'
import Companyinformation from '../entities/companyinformation'
 
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface CompanyinformationState extends ListState<Companyinformation>{
    editCompanyinformation:Companyinformation;
    regionlist:null;
    province:string,
    city:string,
    county:string,
    villages:string,
    citylist:object,
    countylist:object,
    villageslist:object,
    
}
class CompanyinformationModule extends ListModule<CompanyinformationState,any,Companyinformation>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Companyinformation>(),
        loading:false,
        editCompanyinformation:new Companyinformation(),
         regionlist:new Array(),
         citylist:new Array(),
         countylist:new Array(),
         villageslist:new Array()

    }
     

    actions={
        async getAll(context:ActionContext<CompanyinformationState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Companyinformation/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Companyinformation>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getRegionAlList(context:ActionContext<CompanyinformationState,any>,payload:any){
           
            let reponse=await Ajax.get('/api/services/app/Companyinformation/GetRegionAlList',{params:payload.data});
            
            let page=reponse.data.result;
           
            context.state.regionlist=page;
        },

        async create(context:ActionContext<CompanyinformationState,any>,payload:any){
            await Ajax.post('/api/services/app/Companyinformation/Create',payload.data);
        },
        async update(context:ActionContext<CompanyinformationState,any>,payload:any){
            await Ajax.put('/api/services/app/Companyinformation/Update',payload.data);
        },
        async delete(context:ActionContext<CompanyinformationState,any>,payload:any){
            await Ajax.delete('/api/services/app/Companyinformation/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CompanyinformationState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Companyinformation/Get?Id='+payload.id);
            return reponse.data.result as Companyinformation;
        },
        async getOrdAll(context:ActionContext<CompanyinformationState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OrderManagement/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Companyinformation>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
    };
    mutations={
        setCurrentPage(state:CompanyinformationState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CompanyinformationState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CompanyinformationState,companyinformation:Companyinformation){
            state.editCompanyinformation=companyinformation;
        },

        change_citylist(state:CompanyinformationState,vaue:[]){

            state.citylist=vaue;
          
        },
        change_countylist(state:CompanyinformationState,vaue:[]){
 
            state.countylist=vaue;
          
        },
        change_villageslist(state:CompanyinformationState,vaue:[]){

            state.villageslist=vaue;
          
        },
    }
}
const companyinformationModule=new CompanyinformationModule();
export default companyinformationModule;